import { coreValues } from '../../../mocks/ueber-uns';

export default function KernwerteSection() {
  return (
    <section id="kernwerte" className="py-20 sm:py-24 bg-[#e9e4dc]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14 sm:mb-16">
          <span className="inline-block text-xs font-semibold tracking-widest text-[#0D2B4E]/75 uppercase mb-3">
            Was uns antreibt
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0D2B4E] mb-4">Unsere Kernwerte</h2>
          <p className="text-gray-600 text-base sm:text-lg leading-relaxed">
            Diese Überzeugungen leiten uns täglich — auf jeder Baustelle, in jedem Gespräch,
            bei jedem Handgriff.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {coreValues.map((value) => (
            <div
              key={value.id}
              className="bg-white rounded-xl p-7 sm:p-8 border border-gray-100 hover:border-[#0D2B4E]/25 transition-all group"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#0D2B4E]/10 rounded-xl mb-5 group-hover:bg-[#0D2B4E]/18 transition-colors">
                <i className={`${value.icon} text-[#0D2B4E] text-2xl`} />
              </div>
              <h3 className="text-lg font-bold text-[#0D2B4E] mb-3">{value.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>

        {/* Quote */}
        <div className="mt-16 sm:mt-20 bg-[#0D2B4E] rounded-2xl p-8 sm:p-12 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-48 h-48 opacity-5">
            <i className="ri-double-quotes-r text-white" style={{ fontSize: '12rem', lineHeight: 1 }} />
          </div>
          <div className="relative max-w-3xl">
            <p className="text-xl sm:text-2xl lg:text-3xl font-medium text-white leading-relaxed mb-6 italic">
              „Wir bauen nicht nur Gebäude und Gärten — wir schaffen Orte, an denen Menschen sich wohlfühlen. Das war unser Antrieb am ersten Tag und ist es noch heute."
            </p>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                <img
                  src="https://static.readdy.ai/image/42a59d03aabdb3bbb4adf980fce8c22a/8af539e3f70f99ed0ee7523e7c61a4aa.jpeg"
                  alt="Ilker Sahin"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div>
                <p className="font-semibold text-white text-sm">Ilker Sahin</p>
                <p className="text-white/75 text-xs">Gründer &amp; Geschäftsführer, IGM Facility Service</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
